export default "__VITE_ASSET__g4hUMg5$__"